import type { ContactInfoData, ModalData, SlideshowData } from '..';

export interface BreederOverviewModalModalData {
  modal: ModalData;
  loading: boolean;
  title?: string;
  content?: {
    description?: string;
    activity?: string;
    activities?: string;
    housing?: string;
    health?: string;
    parentsSelection?: string;
    puppiesLivingPlace?: string;
    puppiesWork?: string;
  };
  name?: string;
  slideshow?: SlideshowData;
  contactInfo?: ContactInfoData;
  breedNames?: string[] | undefined;
}

export interface BreederOverviewModalProps extends BreederOverviewModalModalData {}
